document.addEventListener("DOMContentLoaded", async function () {
  const goldEl = document.getElementById("goldPrice");
  const silverEl = document.getElementById("silverPrice");
  const platinumEl = document.getElementById("platinumPrice");

  if (!goldEl || !silverEl || !platinumEl) return;

  const API_KEY = "goldapi-1km4rsml9xqwsw-io";

  async function fetchMetal(symbol, el, label) {
    try {
      const res = await fetch(`https://www.goldapi.io/api/${symbol}/USD`, {
        headers: {
          "x-access-token": API_KEY,
          "Accept": "application/json"
        }
      });

      if (!res.ok) throw new Error(res.status);

      const data = await res.json();
      const price = data.price || data.ask || data.bid;

      if (!price) throw new Error("No price field");

      el.textContent = `${label} $${Number(price).toFixed(2)}`;
    } catch (err) {
      console.error(`${label} API error`, err);
      el.textContent = `${label} `;
    }
  }

  fetchMetal("XAU", goldEl, "Gold");
  fetchMetal("XAG", silverEl, "Silver");
  fetchMetal("XPT", platinumEl, "Platinum");
});
